<template>
  <div class="schedule">
    <div class="schedule-wrap">
      <!-- 日期选择 -->
      <div class="schedule-date">
        <Date :includeSchedule="includeSchedule" @change="dateChange" />
      </div>
      <!-- 日程详情 -->
      <div class="schedule-detail"></div>
    </div>
  </div>
</template>

<script>
import Date from '@/components/date'
export default {
  name: 'schedule',
  components: {
    Date
  },
  data () {
    return {}
  },
  props: {
    // 日程列表
    includeSchedule: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    dateChange (date) {
      this.$emit('dateChange', date)
    }
  }
}
</script>
<style lang="scss" scoped>
.schedule {
  &-wrap {
    display: flex;
    .schedule-date {
      flex: 1;
      /deep/ .el-calendar-table__row {
        td {
          height: 50px;
        }
      }
    }
  }
}
</style>
